import { render } from "./SinistroCobrancaDetalheView.vue?vue&type=template&id=79cf852e&scoped=true"
import script from "./SinistroCobrancaDetalheView.vue?vue&type=script&lang=js"
export * from "./SinistroCobrancaDetalheView.vue?vue&type=script&lang=js"

import "./SinistroCobrancaDetalheView.vue?vue&type=style&index=0&id=79cf852e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79cf852e"]])

export default __exports__